var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDollarCoinOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 35.7114C28.6773 35.7114 35.7114 28.6773 35.7114 20C35.7114 11.3228 28.6773 4.28857 20 4.28857C11.3228 4.28857 4.28857 11.3228 4.28857 20C4.28857 28.6773 11.3228 35.7114 20 35.7114Z",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1136 15.7032C23.9722 15.303 23.7539 14.9389 23.4764 14.629C22.8863 13.9696 22.0287 13.5547 21.0742 13.5547H18.5796C16.9908 13.5547 15.7028 14.8427 15.7028 16.4315C15.7028 17.7834 16.6441 18.953 17.9648 19.2419L21.7629 20.0727C23.2425 20.3964 24.297 21.7075 24.297 23.2221C24.297 25.002 22.8541 26.4461 21.0742 26.4461H18.9256C17.5224 26.4461 16.3286 25.5493 15.8861 24.2975",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 13.5543V10.3314",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 29.6681V26.4453",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDollarCoinOutline);
export default __webpack_public_path__ + "static/media/icon_dollar_coin_outline.b8f08b5fb5688533cd30806adeca254f.svg";
export { ForwardRef as ReactComponent };